"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const build_1 = __importStar(require("../../../currency/build"));
const DataModel_1 = __importDefault(require("./DataModel"));
const Transactions_1 = __importDefault(require("../resources/Transactions"));
const Rewards_1 = __importDefault(require("../resources/Rewards"));
const Roles_1 = __importDefault(require("../resources/Roles"));
class Validator extends DataModel_1.default {
    constructor(client, validator) {
        var _a, _b, _c;
        super();
        this.client = client;
        this.versionHeartbeat = validator.version_heartbeat;
        this.status = {
            height: ((_a = validator.status) === null || _a === void 0 ? void 0 : _a.height) || 0,
            online: ((_b = validator.status) === null || _b === void 0 ? void 0 : _b.online) || '',
            listenAddrs: ((_c = validator.status) === null || _c === void 0 ? void 0 : _c.listen_addrs) || [],
        };
        this.stakeStatus = validator.stake_status;
        this.stake = new build_1.default(validator.stake, build_1.CurrencyType.networkToken);
        this.penalty = validator.penalty;
        this.penalties = validator.penalties;
        this.owner = validator.owner;
        this.name = validator.name;
        this.lastHeartbeat = validator.last_heartbeat;
        this.consensusGroups = validator.consensus_groups;
        this.blockAdded = validator.block_added;
        this.block = validator.block;
        this.address = validator.address;
    }
    get activity() {
        return new Transactions_1.default(this.client, this);
    }
    get roles() {
        return new Roles_1.default(this.client, this);
    }
    get rewards() {
        return new Rewards_1.default(this.client, this);
    }
    get data() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = this, { client } = _a, rest = __rest(_a, ["client"]);
        return Object.assign({}, rest);
    }
}
exports.default = Validator;
//# sourceMappingURL=Validator.js.map